import React, { useEffect, useState } from "react"
import * as AppConstants from "../../utility/AppConstants"
import * as Utility from "../../utility/Utility"

// PDF;
import save from "save-file"

// REST
import axios from "axios"
// TAB
import TabRegionali from "../tab/regionali/TabRegionali"

import Breadcrumb from "../breadcrumb/Breadcrumb"
import NotaMetodologicaPDF from '../../../pdf/NTM_Internet_Singolo.pdf'

interface DatiRegionaliProps {
    anno: string
    codIsa?: string
    macroarea?: string
    tipologia?: string
}

function DatiRegionali(props: DatiRegionaliProps) {
    const [datiRegionali, setDatiRegionali] = useState<
        { [key: string]: any } | undefined
    >(undefined)

    useEffect(() => {
        const url = AppConstants.URL_GET_DATI_REGIONALI
        const config = AppConstants.HEADER_CONFIG

        axios
            .get(url, {
                params: {
                    anno: props.anno,
                    codIsa: props.codIsa,
                    macroarea: props.macroarea
                },
                headers: config
            })
            .then((response) => {
                setDatiRegionali(response.data)
            })
            .catch((err) => {})
        return () => {}
    }, [props.anno, props.codIsa, props.macroarea])

    function getTitle(props: Omit<DatiRegionaliProps, "anno">) {
        let title = "Dati Regionali "
        if (props.codIsa !== null && props.codIsa !== undefined)
            title += "Codici ISA"
        else if (props.macroarea !== null && props.macroarea !== undefined)
            title += "Macrosettori"
        else title += "ISA"
        return title
    }

    let title = getTitle(props)

    return (
        <div className="main-min-vh" role="main">
            <div className="container-fluid py-3 py-md-4">
                <Breadcrumb voce={title} />
                <div className="row">
                    <div className="col-auto">
                        <h1>
                            {title} -{" "}
                            {Utility.getValoreHeader(
                                props.codIsa,
                                props.macroarea
                            )}{" "}
                            - {props.anno}{" "}
                        </h1>
                    </div>

                    <div className="col">&nbsp;</div>

                    <div className="col-auto">
                        {datiRegionali !== undefined &&
                        datiRegionali.returnCode === "000" ? (
                            <a
                                rel="noopener noreferrer"
                                title="Download EXCEL Dati Regionali"
                                href="downloadExcel"
                                onClick={(e) =>
                                    downloadExcelDatiRegionali(props, e)
                                }
                            >
                                <i className="fas fas fa-file-excel fa-3x mr-2"></i>
                            </a>
                        ) : (
                            <React.Fragment />
                        )}

                        {datiRegionali !== undefined &&
                        datiRegionali.returnCode === "000" ? (
                            <a
                                aria-hidden="true"
                                rel="noopener noreferrer"
                                title="Download PDF Dati Regionali"
                                href="downloadPDF"
                                onClick={(e) =>
                                    downloadPDFDatiRegionali(props, e)
                                }
                            >
                                <i className="fas fas fa-file-pdf fa-3x mr-2"></i>
                            </a>
                        ) : (
                            <React.Fragment />
                        )}
                    </div>

                    <div className="col-auto">
                        <a
                            aria-hidden="true"
                            href={NotaMetodologicaPDF
                                // process.env.CONTEXT_PATH +
                                // "/public/resources/pdf/Nota_Metodologica.pdf"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Nota Metodologica"
                        >
                            <span className="fas fa-info-circle fa-3x mr-2"></span>
                        </a>
                    </div>
                </div>

                {datiRegionali !== undefined ? (
                    <TabRegionali
                        datiRegionali={datiRegionali}
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        anno={props.anno}
                    />
                ) : (
                    <React.Fragment />
                )}
            </div>
        </div>
    )
}

function downloadPDFDatiRegionali(
    props: DatiRegionaliProps,
    e: React.MouseEvent<any>
) {
    e.preventDefault()
    let nomePDF = `datiRegionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName("region_chart")
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "fileRegion1",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(0) as Node)
        )
    )
    formData.append(
        "fileRegion2",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(1) as Node)
        )
    )
    formData.append(
        "fileRegion3",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(2) as Node)
        )
    )
    formData.append(
        "fileRegion4",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(3) as Node)
        )
    )
    formData.append(
        "fileRegion5",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(4) as Node)
        )
    )

    axios
        .post(AppConstants.URL_GET_PDF_DATI_REGIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
        })
        .catch((err) => {})
}

function downloadExcelDatiRegionali(
    props: DatiRegionaliProps,
    e: React.MouseEvent<any>
) {
    e.preventDefault()
    let nomeExcel = `datiRegionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName("region_chart")
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "fileRegion1",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(0) as Node)
        )
    )
    formData.append(
        "fileRegion2",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(1) as Node)
        )
    )
    formData.append(
        "fileRegion3",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(2) as Node)
        )
    )
    formData.append(
        "fileRegion4",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(3) as Node)
        )
    )
    formData.append(
        "fileRegion5",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(4) as Node)
        )
    )

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_REGIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
        })
        .catch((err) => {})
}

export default DatiRegionali
